// extracted by mini-css-extract-plugin
module.exports = {"error-notification":"_3K3KM7TE-vPEVWAzJKmotF","error-notification__icon":"_2RwTRwASxz3xmNBMAim9fM"};